/**
 * Utility function to split arrays into chunks for Firestore queries
 * Firebase 'in' operator supports max 30 values
 */
export function chunkArrayForFirestore<T>(array: T[], chunkSize: number = 30): T[][] {
  const chunks: T[][] = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}
